import React from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { CheckClimaEl } from '../../../style'
import { Checkbox, Grid, Input } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { ClimateCheckSelectType } from '~/api/services/climaCheck'

interface Props {
  manureFermentations: ClimateCheckSelectType[]
}

const RecycledManure: React.FC<Props> = ({ manureFermentations }) => {
  const { t } = useTranslation()
  const { control, getValues, clearErrors, formState } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'calvesManureFermentations',
    keyName: 'key'
  })

  function checkPercentage() {
    const calvesManureFermentations = getValues('calvesManureFermentations')
    return calvesManureFermentations.reduce((previousValue, currentValue) => {
      return previousValue + parseFloat(currentValue?.percent?.replace(',', '.'))
    }, 0) > 100
  }

  function handleChecked(field, checked) {
    if (checked) {
      append({
        ...field,
        percent: ''
      })
      return
    }
    const index = fields.findIndex(fieldManure => fieldManure['id'] === field.id)
    if (index >= 0) {
      remove(index)
    }
  }

  return <div style={{ marginTop: '3em' }}>
    <div style={{ width: 'fit-content' }}>
      <div>{'Verwerten Sie auch Mist in der BGA?'}</div>
      <CheckClimaEl.StyledDivider />
    </div>
    <Grid columns={2} style={{ marginTop: '1em' }}>
      <Controller
        name={'calvesManureFermentations'}
        control={control}
        rules={{
          validate: () => !checkPercentage()
        }}
        render={({ fieldState }) => {
          const percentageError = !!fieldState.error
          return <>
            {manureFermentations.map((option) => {
              const fieldIndex = fields.findIndex(field => field['id'] === option.id)
              const hasRequiredError = Boolean(formState.errors?.calvesManureFermentations?.[fieldIndex]?.percent)
              const error = percentageError || hasRequiredError
              return <Grid.Row key={`calvesManureFermentations-${option.id}`} style={{ padding: 0 }}>
                <Grid columns={2}>
                  <Grid.Row
                    style={{ alignItems: 'center', padding: '0.6rem 0rem' }}>
                    <Grid.Column>
                      <Checkbox
                        label={option.label}
                        checked={Boolean(fields.find(manureField => manureField['id'] === option.id))}
                        onChange={(e, data) => handleChecked(option, data.checked)}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      {fieldIndex >= 0 ? <FormFields.Input
                        control={control}
                        allowDecimals
                        decimalScale={2}
                        styleLabel={{ marginBottom: 0 }}
                        style={{ width: 200 }}
                        onBlur={() => {
                          if (!checkPercentage()) {
                            clearErrors('calvesManureFermentations')
                          }
                        }}
                        error={error}
                        typeInput={'controled'}
                        suffix={' %'}
                        noErrorMessage
                        withoutAsterisk
                        rules={{
                          required: true
                        }}
                        name={`calvesManureFermentations[${fieldIndex}].percent`}
                        placeholder={t('in %')}
                      /> : <Input
                        style={{ width: 200 }}
                        disabled
                        placeholder={t('in %')}
                      />
                      }
                    </Grid.Column>
                  </Grid.Row>

                </Grid>
              </Grid.Row>
            })}
          </>
        }}
      />
    </Grid>
  </div>
}
export default RecycledManure